import { FC, useCallback, useMemo } from 'react';
import { CoreTableActionsCell, CellAction } from '../../../../_core/components/_ui/core-table';
import { FamiliesDetailsTableHandlers } from './families-details-table.component';
import { DeleteIcon, EditIcon, EyeIcon, SendSmsIcon, ShareIcon } from '../../../../_core/components/icons';
import { SurveyAnswerDto, SurveyStatusEnum } from '@families-link/shared';
import { UnrecognizedSurveyAnswersTableHandlers } from './families-unrecognized-answers-table.component';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
export interface UnrecognizedSurveyAnswersTableActionsProps extends UnrecognizedSurveyAnswersTableHandlers {
	surveyAnswer: SurveyAnswerDto;
}

export const UnrecognizedAnswersTableActions: FC<UnrecognizedSurveyAnswersTableActionsProps> = (props) => {
	const { surveyAnswer, onAttachFamily, onDelete, onView } = props;
	const [t] = useTranslation();

	const handleAttachFamilySurveyAnswer = useCallback(() => {
		if (!surveyAnswer) {
			return;
		}

		onAttachFamily?.(surveyAnswer);
	}, [onAttachFamily, surveyAnswer]);

	const handleDeleteSurveyAnswer = useCallback(() => {
		if (!surveyAnswer) {
			return;
		}

		onDelete?.(surveyAnswer);
	}, [onDelete, surveyAnswer]);
	
	const handleViewFamily = useCallback(() => {
		if (!surveyAnswer) {
			return;
		}

		onView?.(surveyAnswer);
	}, [onView, surveyAnswer]);

	const actions = useMemo<CellAction[]>(
		() => [
			{
				id: 'view',
				type: 'button',
				tooltipTitle: t('buttons.tooltips.full-details'),
				props: {
					children: <EyeIcon sx={{ fontSize: 30 }} color="primary" />,
					onClick: handleViewFamily,
				},
			},
			{
				id: 'more',
				type: 'menu',
				props: {
					options: [
						{
							id: 'atttach',
							label: 'Assign to family',
							icon: <Add color="primary" />,
							onClick: handleAttachFamilySurveyAnswer,
						},
						{
							id: 'delete',
							label: 'Delete',
							icon: <DeleteIcon color='error' />,
							onClick: handleDeleteSurveyAnswer,
						},
					],
				},
			},
		],
		[handleViewFamily, handleAttachFamilySurveyAnswer, handleDeleteSurveyAnswer]
	);

	return <CoreTableActionsCell actions={actions} />;
};
